import React, { useEffect, useState } from 'react'
import { uid } from '@zera-admin/utils'
import Breadcrumb, { BreadcrumbItem } from '@zera-admin/breadcrumb'
import Button, { ButtonGroup, LinkButton } from '@zera-admin/button'
import Page, { PageHeader, Container } from '@zera-admin/page'

import { useFlagcardContext } from 'app/contexts/flagcard'
import { ValidationError } from 'app/shared/types'
import MainLayout from 'layouts/main'
import botClassificationsService, {
  BotClassification,
  UpdateBotClassificationRequest,
} from 'services/http/dataset/bot-classification'

import { UpdateBotClassificationProps } from './types'
import BotClassificationForm from './BotClassificationForm'

const UpdateBotClassification: React.FunctionComponent<UpdateBotClassificationProps> =
  ({ match, history }) => {
    const [isLoading, setIsLoading] = useState(false)
    const [isReady, setIsReady] = useState(true)
    const [botClassification, setBotClassification] =
      useState<BotClassification>()
    const [flagcard] = useFlagcardContext()

    useEffect(() => {
      const id = parseInt(match.params.id)

      botClassificationsService
        .getById(id)
        .then((res) => {
          setBotClassification(res.data)
        })
        .catch((err: Error) => {
          console.log(err)
        })
        .finally(() => {
          setIsReady(false)
        })
    }, [match.params.id, history])

    const handleSubmit = (data: UpdateBotClassificationRequest) => {
      if (data) {
        setIsLoading(true)

        botClassificationsService
          .update(data)
          .then(() => {
            flagcard.add({
              id: uid(),
              appearance: 'success',
              title: 'İşlem Başarılı',
              children:
                'Geçerli veri, sistem üzerinde başarıyla güncellenmiştir.',
            })
          })
          .catch((error) => {
            console.log(error)

            flagcard.add({
              id: uid(),
              appearance: 'error',
              title: 'Hata Oluştu',
              children:
                'Geçerli veri güncellenirken bir hata oluştu. Lütfen tekrar deneyin. Sorununuz düzelmediyse servis sağlayıcısı ile iletişime geçiniz.',
            })
          })
          .finally(() => {
            setIsLoading(false)
          })
      }
    }

    const handleError = (error?: ValidationError) => {
      console.log(error)
    }

    const breadcrumbs = (
      <Breadcrumb>
        <BreadcrumbItem text="Anasayfa" href="/" />
        <BreadcrumbItem text="Bot sınıflandırması" href="/bot-classification" />
        <BreadcrumbItem text="Bot sınıflandırması güncelle" />
      </Breadcrumb>
    )

    return (
      <MainLayout isLoading={isReady}>
        <Container width="medium">
          <Page>
            <PageHeader
              // actions={<Button appearance="error">Delete user</Button>}
              breadcrumbs={breadcrumbs}
              bottomBar={
                <p>
                  Aşağıdaki bilgileri doldurarak geçerli bot sınıflandırmalarını
                  güncelleyebilirsiniz.
                </p>
              }
            >
              Veri güncelleniyor:{' '}
              {botClassification ? botClassification.personUserId : null}
            </PageHeader>
            <BotClassificationForm
              actions={
                <ButtonGroup>
                  <Button
                    appearance="primary"
                    children="Güncelle"
                    isLoading={isLoading}
                    type="submit"
                  />
                  <LinkButton href="/bot-classification">İptal</LinkButton>
                </ButtonGroup>
              }
              operation="update"
              onSubmit={handleSubmit}
              onError={handleError}
              values={botClassification}
            />
          </Page>
        </Container>
      </MainLayout>
    )
  }

export default UpdateBotClassification
